export default __webpack_public_path__ + "static/media/photo--sm--79.38350694.jpg";